const doctors = [
    {
        id: 1,
        name: "Dr. Nishant Tripathy",
        founder: "Chairman",
        speciality: "Chairman & Interventional Cardiologist",
        designation: "MD(Medicine), DM(Cardiology), Chairman, Department of Interventional Cardiology",
        image: "https://cdn.dotplus.in/Cloud/Aarogyam/home/doctors/doctor_photo-01.webp",
        description: "<b>Dr. Nishant Tripathy</b> is a leading interventional cardiologist with extensive experience. He has introduced advanced techniques like OCT, IVUS, and TAVI in Bihar.",
        slug: "dr-nishant-tripathy",
        alt: "Dr. Nishant Tripathy - Chairman"
    },
    {
        id: 2,
        name: "Dr. Ashok Kumar",
        founder: "Director",
        speciality: "Director, Institute of Cardiac Science",
        designation: "Director, Institute of Cardiac Science",
        image: "https://cdn.dotplus.in/Cloud/Aarogyam/home/doctors/doctor_photo-05.webp",
        description: "<b>Dr. Ashok Kumar</b> is a trained Cardiologist from the prestigious SGPGI Lucknow. He has been credited with starting Mahavir Vatsalya Cardiology Department in Bihar. With over 13 years of experience, he has performed more than 15,000 coronary angiographies, 5,000 angioplasties, and many other complex procedures. He is a Fellow of the American Society of Cardiology and the European Society of Cardiology.",
        slug: "dr-ashok-kumar",
        alt: "Dr. Ashok Kumar - Director"
    },
    {
        id: 3,
        name: "Dr. Harsh Vardhan",
        founder: "Director",
        speciality: "Director, Institute of Renal Science",
        designation: "Director, Institute of Renal Science",
        image: "https://cdn.dotplus.in/Cloud/Aarogyam/home/doctors/doctor_photo-04.webp",
        description: "<b>Dr. Harsh Vardhan</b> is a trained Nephrologist from SGPGI Lucknow and has been pivotal in starting renal transplantation programs in Bihar. He is a Fellow of the American Society of Nephrology.",
        slug: "dr-harsh-vardhan",
        alt: "Dr. Harsh Vardhan - Director"
    },
    {
        id: 4,
        name: "Dr. (Lt. Col.) S K Jha",
        speciality: "Senior Consultant, Department of Neurology",
        designation: "MD, DM (Neurosurgery), FAAN, FIMSA, FIACM, Senior Consultant, Department of Neurology",
        image: "https://cdn.dotplus.in/Cloud/Aarogyam/home/doctors/S_K_Jha-01.webp",
        description: "",
        slug: "dr-lt-col-s-k-jha",
        alt: "Dr. S.K. Jha - Senior Consultant"
    },
    // {
    //     id: 5,
    //     name: "Dr. Shyam Sunder",
    //     speciality: "Senior Consultant, Department of Neurosurgery",
    //     designation: "Senior Consultant, Department of Neurosurgeon",
    //     image: "https://cdn.dotplus.in/Cloud/Aarogyam/home/doctors/doctor_photo-02.webp",
    //     description: "<b>HDNA Aarogyam Hospital</b>, Patna as done his MBBS from Patna Medical College. Has done his DNB in neurosurgery. He is a fellow of European Board of Neurological Surgeon (FEBNS). He has done his fellowship in spine surgery from Zurich. He has done fellowship in endoscopic brain and spine surgery from Germany. He has done his fellowship in stereotactic brain surgery from France. He has done his skull base surgery fellowship from Germany. He has done neurovascular fellowship from Denmark. He has worked as a consultant neurosurgeon at Tirath Ram Shah Hospital, Apollo Hospital and Fortis Hospital Delhi. He has a total experience of 23 years in the field of Neurosurgery.",
    //     slug: "dr-shyam-sunder",
    //     alt: "Dr. Shyam Sunder - Senior Consultant" 
    // },
    {
        id: 6,
        name: "Dr. Apurva Chaudhary",
        speciality: "Senior Consultant, Department of Urology",
        designation: "MBBS, MS(General Surgery), DNB(Urology/Genitourinary-Urinary surgery) Senior Consultant, Department of Urology",
        image: "/images/doctors/draporva.webp",
        description: "",
        slug: "dr-apurva-chaudhary",
        alt: "Dr. Apurva Chaudhary - Senior Consultant"
    },
    {
        id: 7,
        name: "Dr. Dhiraj Kumar Ambastha",
        founder: "Medical Director",
        speciality: "Director, Department of Anesthesiology & Critical Care",
        designation: "Director of Anesthesiology & Critical",
        image: "https://cdn.dotplus.in/Cloud/Aarogyam/home/doctors/doctor_photo-03.webp",
        description: "<b>Dr. Dhiraj Kumar Ambastha</b> is the Director of Emergency & Critical Care at HDNA Aarogyam Hospital, Vast Experience in critical care and a gold medallist in Anaesthesia.",
        slug: "dr-dhiraj-kumar-ambastha",
        alt: "Dr. Dhiraj Kumar Ambastha - Medical Director"
    },
    // {
    //     id: 8,
    //     name: "Dr. Tauseef Nissar",
    //     founder: "Medical Superintendent",
    //     speciality: "Medical Superintendent",
    //     designation: "Medical Superintendent",
    //     image: "https://cdn.dotplus.in/Cloud/Aarogyam/home/doctors/doctor_photo-06.webp",
    //     description: "<b>Dr. Tauseef Nissar</b> is a Non-invasive Cardiologist with thirteen years of experience in healthcare. Skilled in providing quality care to cardiac patients, interpretation of ECG & TMT, doing Echocardiography, and temporary Pacemaker Implantation and other non-invasive cardiac care.",
    //     slug: "dr-tauseef-nissar",
    //     alt: "Dr. Tauseef Nissar - Medical Superintendent"
    // },
        {
        id: 8,
        name: "Dr. Tauseef Nissar",
        founder: "Director",
        speciality: "Director",
        designation: "Director",
        image: "https://cdn.dotplus.in/Cloud/Aarogyam/home/doctors/doctor_photo-06.webp",
        description: "<b>Dr. Tauseef Nissar</b> is a Non-invasive Cardiologist with thirteen years of experience in healthcare. Skilled in providing quality care to cardiac patients, interpretation of ECG & TMT, doing Echocardiography, and temporary Pacemaker Implantation and other non-invasive cardiac care.",
        slug: "dr-tauseef-nissar",
        alt: "Dr. Tauseef Nissar - Director"
    },
    {
        id: 9,
        name: "Dr. Sharjeel Rasheed",
        speciality: "Senior Consultant, Department of Orthopedics",
        designation: "MBBS, MS(Ortho), Fellowship in Sports Injury Consultant, Senior Consultant, Department of Orthopedics",
        image: "https://cdn.dotplus.in/Cloud/Aarogyam/home/doctors/Dr_Sharjeel_Rasheed-01.webp",
        description: "",
        slug: "dr-sharjeel-rasheed",
        alt: "Dr. Sharjeel Rasheed - Senior Consultant"
    },
    {
        id: 10,
        name: "Dr. Mohit Saxena",
        speciality: "Senior Consultant, Department of Cardiothoracic & Vascular Surgery",
        designation: "Senior Consultant, Department of Cardio Thoracic and Vascular Surgery CTVS",
        image: "https://cdn.dotplus.in/Cloud/Aarogyam/home/doctors/doctor_photo-12.webp",
        description: "",
        slug: "dr-mohit-saxena",
        alt: "Dr. Mohit Saxena - Senior Consultant"
    },
    // {
    //     id: 11,
    //     name: "Mr. Vipul Tiwary",
    //     speciality: "Managing Director",
    //     designation: "Managing Director",
    //     founder: "Founder",
    //     image: "https://cdn.dotplus.in/Cloud/Aarogyam/home/doctors/doctor_photo-07.webp",
    //     description: "Mr. Vipul Tiwary is the Managing Director of HDNA Arogyam Hospital, a leading healthcare institution committed to excellence in patient care and innovation. Under his leadership, the hospital has expanded its services, integrating advanced medical technologies and a compassionate approach to healthcare, ensuring quality treatment and community well-being.",
    //     slug: "mr-vipul-tiwary",
    //     alt: "Mr. Vipul Tiwary - Managing Director"
    // }
       {
        id: 11,
        name: "Mr. Vipul Tiwary",
        speciality: "Director",
        designation: "Director",
        founder: "Director",
        image: "https://cdn.dotplus.in/Cloud/Aarogyam/home/doctors/doctor_photo-07.webp",
        description: "Mr. Vipul Tiwary is the Director of HDNA Arogyam Hospital, a leading healthcare institution committed to excellence in patient care and innovation. Under his leadership, the hospital has expanded its services, integrating advanced medical technologies and a compassionate approach to healthcare, ensuring quality treatment and community well-being.",
        slug: "mr-vipul-tiwary",
        alt: "Mr. Vipul Tiwary - Director"
    }
];
export default doctors; 